function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook();

  this.SheetNames = [];

  this.Sheets = {};
}

const download = (url, name) => {
  let a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();

  window.URL.revokeObjectURL(url);
};

function s2ab(s) {
  const buf = new ArrayBuffer(s.length);

  const view = new Uint8Array(buf);

  for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;

  return buf;
}

export default (data, type) => {
  import('xlsx').then(XLSX => {
    const wb = new Workbook();
    const ws = XLSX.utils.json_to_sheet(data);

    wb.SheetNames.push('sheet1');
    wb.Sheets['sheet1'] = ws;

    let now = new Date();
    let date =
      now.getFullYear() +
      '' +
      (now.getMonth() + 1) +
      '' +
      now.getDate() +
      '' +
      now.getHours() +
      '' +
      now.getMinutes() +
      '' +
      now.getSeconds();

    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary',
    });

    let url = window.URL.createObjectURL(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }));

    download(url, 'export_' + type + '_' + date + '.xlsx');
  });
};



// WEBPACK FOOTER //
// ./src/components/Export/ExportToXLSX.js